import { Banner, Text } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";

export interface NonMatchingProductBannerProps {
  onPress?: () => void | Promise<void>;
}

export const NonMatchingProductBanner = ({
  onPress,
}: NonMatchingProductBannerProps) => {
  const { t } = useTranslation("invoice_arrival");
  return (
    <Banner
      status="warning"
      title={t("banner.non_matching_product.title")}
      onPress={onPress}
    >
      <Text>{t("banner.non_matching_product.description")}</Text>
    </Banner>
  );
};
